module.exports = __webpack_public_path__ + "img/microsoft-logo.36fed8e7.png";